// Keep a random retry capability until confirmed closure, including across reloads; never derive it
// from a publicly visible conversation/session identifier.
export function handoffRequestKey(scope: string): string {
  const storageKey = `handoff.pending:${scope}`;
  const previous = sessionStorage.getItem(storageKey);
  if (previous) return previous;
  const key = crypto.randomUUID();
  sessionStorage.setItem(storageKey, key);
  return key;
}
export function completeHandoffRequest(scope: string) {
  sessionStorage.removeItem(`handoff.pending:${scope}`);
}
